import { render } from "./iamgeList.vue?vue&type=template&id=8009fb0c"
import script from "./iamgeList.vue?vue&type=script&lang=js"
export * from "./iamgeList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__